import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="py-3" data-testid="breadcrumbs">
      <ol className="flex items-center gap-1.5 text-xs tracking-wide">
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1.5">
            {idx > 0 && <ChevronRight className="w-3 h-3 text-gray-300" />}
            {idx === 0 ? (
              <Link to={item.url || '/'} className="text-gray-400 hover:text-[#c5a059] transition-colors flex items-center gap-1">
                <Home className="w-3 h-3" />
                <span>{item.name}</span>
              </Link>
            ) : item.url ? (
              <Link to={item.url} className="text-gray-400 hover:text-[#c5a059] transition-colors">
                {item.name}
              </Link>
            ) : (
              <span className="text-[#1a1a1a] font-semibold">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
